export async function hashIdentifier(
  orderNumber?: string,
  trackingNumber?: string,
): Promise<string | null> {
  const identifier = orderNumber || trackingNumber;
  if (!identifier) return null;

  const encoded = new TextEncoder().encode(identifier);
  const buffer = await crypto.subtle.digest('SHA-256', encoded);
  const hex = Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return hex.slice(0, 16);
}
